/**
 * @generated SignedSource<<0206106c1d086a0b236081f1bea3a0a8>>
 * @relayHash 9816d142eafcfdbd3ae0a4234355dbff
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9816d142eafcfdbd3ae0a4234355dbff

import { ConcreteRequest } from 'relay-runtime';
export type Ch_checkPartnerPortalEligibilityInput = {
  address: AddressInput;
  patientId: string;
};
export type AddressInput = {
  city: string;
  countryCode: string;
  houseNumberStreet: string;
  postalCode: string;
};
export type chCheckPartnerPortalEligibilityMutation$variables = {
  input: Ch_checkPartnerPortalEligibilityInput;
};
export type chCheckPartnerPortalEligibilityMutation$data = {
  readonly ch_checkPartnerPortalEligibility: {
    readonly checkPartnerPortalEligibilityOutput: {
      readonly closestCareProvider: {
        readonly businessName: string | null;
        readonly distanceKm: number | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly title: string | null;
      } | null;
      readonly isEligible: boolean;
      readonly nearbyCareProviderIds: ReadonlyArray<number>;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chCheckPartnerPortalEligibilityMutation = {
  response: chCheckPartnerPortalEligibilityMutation$data;
  variables: chCheckPartnerPortalEligibilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CheckPartnerPortalEligibilityOutput",
  "kind": "LinkedField",
  "name": "checkPartnerPortalEligibilityOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEligible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nearbyCareProviderIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClosestCareProvider",
      "kind": "LinkedField",
      "name": "closestCareProvider",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "businessName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "distanceKm",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chCheckPartnerPortalEligibilityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_checkPartnerPortalEligibilityPayload",
        "kind": "LinkedField",
        "name": "ch_checkPartnerPortalEligibility",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chCheckPartnerPortalEligibilityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_checkPartnerPortalEligibilityPayload",
        "kind": "LinkedField",
        "name": "ch_checkPartnerPortalEligibility",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9816d142eafcfdbd3ae0a4234355dbff",
    "metadata": {},
    "name": "chCheckPartnerPortalEligibilityMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c18cbe6c2d3e817fd4b61de7dd597fcd";

export default node;
